/* Accessibility only; original popup open/close and lead handlers remain in control. */
(() => {
  const modal = document.querySelector('#ouibounce-modal2');
  if (!modal) return;
  const phone = modal.querySelector('.PN');
  const setPlaceholder = () => {
    if (!phone || phone.placeholder) return;
    let profile;
    try { profile = JSON.parse(document.querySelector('#hlx-market-data')?.textContent || '{}'); }
    catch { return; }
    if (typeof profile?.phonePrefix === 'string' && /^\+[1-9]\d{0,3}$/.test(profile.phonePrefix)) {
      phone.placeholder = profile.phonePrefix;
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setPlaceholder); else setPlaceholder();
  if (phone) new MutationObserver(setPlaceholder).observe(phone,{attributes:true,attributeFilter:['placeholder']});
  let wasOpen=false, previous=null;
  const visible = () => getComputedStyle(modal).display !== 'none';
  const focusables = () => [...modal.querySelectorAll('button,input,a[href]')].filter(el => !el.disabled && el.getClientRects().length);
  new MutationObserver(() => {
    const open=visible();
    document.documentElement.classList.toggle('hlx-popup-open', open);
    if (open && !wasOpen) { previous=document.activeElement; focusables()[0]?.focus(); }
    if (!open && wasOpen) previous?.focus();
    wasOpen=open;
  }).observe(modal,{attributes:true,attributeFilter:['style','class']});
  modal.addEventListener('keydown', event => {
    if (event.key==='Escape') { modal.querySelector('.close')?.click(); event.preventDefault(); }
    if (event.key==='Tab') { const list=focusables(),first=list[0],last=list.at(-1); if(event.shiftKey && document.activeElement===first){last?.focus();event.preventDefault();} else if(!event.shiftKey&&document.activeElement===last){first?.focus();event.preventDefault();} }
  });
})();
